// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  background-color: #FFFFFF;
}

.logo-text {
  font-family: 'Chivo', sans-serif;
  font-weight: 900;
  font-size: 1.5rem;
  color: #002FA7;
  letter-spacing: -0.02em;
}

.stat-card {
  background: white;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  padding: 1.5rem;
  transition: transform 0.2s ease-out, border-color 0.2s ease-out;
}

.stat-card:hover {
  transform: translateY(-4px);
  border-color: #09090B;
}

.table-container {
  background: white;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  overflow: hidden;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  background: #F4F4F5;
  border-bottom: 1px solid #E4E4E7;
}

thead th {
  padding: 1rem;
  text-align: left;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #52525B;
}

tbody tr {
  border-bottom: 1px solid #E4E4E7;
  transition: background-color 0.15s ease;
}

tbody tr:hover {
  background-color: #F4F4F5;
}

tbody td {
  padding: 1rem;
  color: #09090B;
}

.login-split-screen {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 100vh;
}

@media (max-width: 768px) {
  .login-split-screen {
    grid-template-columns: 1fr;
  }
  
  .login-image-side {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".App {\n  min-height: 100vh;\n  background-color: #FFFFFF;\n}\n\n.logo-text {\n  font-family: 'Chivo', sans-serif;\n  font-weight: 900;\n  font-size: 1.5rem;\n  color: #002FA7;\n  letter-spacing: -0.02em;\n}\n\n.stat-card {\n  background: white;\n  border: 1px solid #E4E4E7;\n  border-radius: 8px;\n  padding: 1.5rem;\n  transition: transform 0.2s ease-out, border-color 0.2s ease-out;\n}\n\n.stat-card:hover {\n  transform: translateY(-4px);\n  border-color: #09090B;\n}\n\n.table-container {\n  background: white;\n  border: 1px solid #E4E4E7;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nthead {\n  background: #F4F4F5;\n  border-bottom: 1px solid #E4E4E7;\n}\n\nthead th {\n  padding: 1rem;\n  text-align: left;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.2em;\n  color: #52525B;\n}\n\ntbody tr {\n  border-bottom: 1px solid #E4E4E7;\n  transition: background-color 0.15s ease;\n}\n\ntbody tr:hover {\n  background-color: #F4F4F5;\n}\n\ntbody td {\n  padding: 1rem;\n  color: #09090B;\n}\n\n.login-split-screen {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  min-height: 100vh;\n}\n\n@media (max-width: 768px) {\n  .login-split-screen {\n    grid-template-columns: 1fr;\n  }\n  \n  .login-image-side {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
